import React from 'react';
// import { withRouter } from 'react-router';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import moment from 'moment';
import { Info } from "@material-ui/icons";
import { backendDateFormat, dayMonthDateFormat,fieldDMYShort } from '../../constants';
import { Paper, Grid, TextField, Tooltip } from '@material-ui/core';
import { regexConstants } from '../../constants/regEx';
import { acumenCamo } from '../../shared_elements/components';
import { Comma_format } from '../../utils';
const EngOnOffWing = ({ match, error, onResetError, pltConstants, onFieldChange, basicDetails, setError,viaBasicDetail}) => {
    return (
        <>
            <Grid container spacing={1}>
                <Grid item md={6} sm={6} xs={12}>
                    {(() => {
                        let options = [{ label: 'On Wing', value: 1 }, { label: 'Off Wing', value: 2 }];
                        return (
                            <Autocomplete
                                disabled={viaBasicDetail}
                                disableClearable
                                options={options}
                                getOptionLabel={option => option?.label}
                                name="on_wing_status"
                                value={basicDetails?.on_wing_status ? { label: 'On Wing', value: 1 } : { label: 'Off Wing', value: 2 }}
                                onChange={(e, value) => { onFieldChange('on_wing_status', value && value.value === 1 ? true : false); onResetError('on_wing_status') }}
                                renderInput={params => <TextField error={error?.on_wing_status} helperText={error?.on_wing_status || ''} {...params} label="Wing Status" margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                            />
                        )
                    })()}
                </Grid>
                {basicDetails?.on_wing_status === false ?
                    <Grid item md={6} sm={6} xs={12}>
                        <Autocomplete
                            disabled={viaBasicDetail}
                            options={pltConstants.filter((optionItem) => optionItem.type === 'off_wing_status')}
                            getOptionLabel={option => option.label}
                            name="off_wing_status"
                            value={basicDetails?.off_wing_status || null}
                            onChange={(e, value) => { onFieldChange('off_wing_status', value,); onResetError('off_wing_status') }}
                            renderInput={params => <TextField error={error?.off_wing_status ? true : false} helperText={error?.off_wing_status || ''} {...params}
                                label={<span>Off Wing Condition
                                    <Tooltip title={
                                        <div style={{ width: '220px' }}>
                                            Assembly can be "On Wing" if the off wing condition is "Off Wing Serviceable" only.
                                        </div>}
                                        arrow>
                                        <Info style={{ fontSize: '13px', marginLeft: '3px' }} />
                                    </Tooltip>
                                </span>}
                                margin="normal" fullWidth InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }} variant='outlined' />}
                        />
                    </Grid> : null
                }
            </Grid>
            {basicDetails?.on_wing_status === true ?
                <Grid container spacing={1}>
                    <Grid item md={6} sm={6} xs={12}>
                        <TextField
                            name='on_wing_msn'
                            label='On Wing MSN'
                            value={basicDetails?.on_wing_msn || ''}
                            fullWidth
                            margin="normal"
                            onChange={(e) => onFieldChange('on_wing_msn', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ maxLength: 50 }}
                            variant='outlined'
                            disabled={viaBasicDetail}
                        />
                    </Grid>
                    <Grid item md={6} sm={6} xs={12}>
                        <TextField
                            name='on_wing_lessor'
                            label='On Wing Owner'
                            value={basicDetails?.on_wing_lessor || ''}
                            fullWidth
                            margin="normal"
                            onChange={(e) => onFieldChange('on_wing_lessor', e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ maxLength: 50 }}
                            variant='outlined'
                            disabled={viaBasicDetail}
                        />
                    </Grid>
                </Grid> : null
            }
            {basicDetails?.on_wing_status === false ?
                <Grid container spacing={1}>
                    {match?.params?.assetType === '2' && (basicDetails?.off_wing_status?.value === 1 || basicDetails?.off_wing_status?.value === 2 || basicDetails?.off_wing_status?.value === 3 || basicDetails?.off_wing_status?.value === 4 || basicDetails?.off_wing_status?.value === 5) ?
                        <>
                            <Grid item md={4} sm={6} xs={12}>
                                <TextField
                                    name='tsn_at_removal'
                                    label='TSN of Engine Removal'
                                    value={basicDetails?.off_wing_detail?.tsn_at_removal ? Comma_format((Number(basicDetails?.off_wing_detail?.tsn_at_removal)).toFixed(2)) : ''}
                                    fullWidth
                                    margin="normal"
                                    // onChange={(e) => regexConstants.numberWithDot.test(e.target.value) ? onFieldChange('tsn_at_removal', e.target.value, 'off_wing_detail') : e.preventDefault()}
                                    InputLabelProps={{ shrink: true }}
                                    inputProps={{ maxLength: 9 }}
                                    variant='outlined'
                                    disabled
                                />
                            </Grid>
                            <Grid item md={4} sm={6} xs={12}>
                                <TextField
                                    name='csn_at_removal'
                                    label='CSN of Engine Removal'
                                    value={basicDetails?.off_wing_detail?.csn_at_removal ? Comma_format(parseInt(basicDetails?.off_wing_detail?.csn_at_removal)) : ''}
                                    fullWidth
                                    margin="normal"
                                    // onChange={(e) => regexConstants.numberNoSpace.test(e.target.value) ? onFieldChange('csn_at_removal', e.target.value, 'off_wing_detail') : e.preventDefault()}
                                    InputLabelProps={{ shrink: true }}
                                    inputProps={{ maxLength: 9 }}
                                    variant='outlined'
                                    disabled
                                />
                            </Grid>
                            <Grid item md={4} sm={6} xs={12}>
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <KeyboardDatePicker
                                        margin="normal"
                                        name="date_of_removal"
                                        label={`Date of Engine Removal`}
                                        format={acumenCamo ? fieldDMYShort :dayMonthDateFormat}
                                        fullWidth
                                        disabled
                                        error={error?.date_of_removal}
                                        helperText={error?.date_of_removal || ''}
                                        InputLabelProps={{ shrink: true }}
                                        minDate={moment().subtract(25, 'years')}
                                        value={basicDetails?.off_wing_detail?.date_of_removal || null}
                                        // onChange={(data, value) => { onFieldChange('date_of_removal', moment(data).isValid() ? moment(data).format(backendDateFormat) : null, 'off_wing_detail', 'date'); }}
                                        inputVariant='outlined'
                                        onBlur={(e) => {
                                            const inputValue = e.target.value;
                                            const isValid = moment(inputValue, dayMonthDateFormat, true).isValid();
                                            if (isValid || inputValue === '') {
                                                setError({})
                                                onFieldChange('date_of_removal', inputValue === '' ? null : inputValue, 'off_wing_detail');
                                            } else {
                                                setError({ ...error, ['date_of_removal']: 'Invalid Date' })
                                            }
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item md={12} sm={12} xs={12}>
                                <TextField
                                    name='reason_for_removal'
                                    label='Reason of Engine Removal'
                                    value={basicDetails?.off_wing_detail?.reason_for_removal || ''}
                                    fullWidth
                                    multiline
                                    margin="normal"
                                    disabled
                                    // onChange={(e) => onFieldChange('reason_for_removal', e.target.value, 'off_wing_detail')}
                                    InputLabelProps={{ shrink: true }}
                                    inputProps={{ maxLength: 250 }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item md={4} sm={6} xs={12}>
                                {(() => {
                                    let options = [{ label: 'Yes', value: true }, { label: 'No', value: false }];
                                    let optionValue = options.find(optionItem => optionItem.value === basicDetails?.off_wing_detail?.preservation_performed);
                                    return (
                                        <Autocomplete
                                            disableClearable
                                            options={options}
                                            disabled={viaBasicDetail}
                                            getOptionLabel={option => option.label}
                                            name="preservation_performed"
                                            value={optionValue}
                                            onChange={(e, value) => onFieldChange('preservation_performed', value !== null ? value.value : null, 'off_wing_detail')}
                                            renderInput={params => <TextField {...params} label="Preservation Performed" margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                        />
                                    )
                                })()}
                            </Grid>
                        </> : null}
                    {basicDetails?.off_wing_status?.value === 2 || basicDetails?.off_wing_status?.value === 3 ?
                        <>
                            {basicDetails?.off_wing_status?.value === 2 ?
                                <>
                                    <Grid item md={4} sm={6} xs={12}>
                                        <MuiPickersUtilsProvider utils={MomentUtils}>
                                            <KeyboardDatePicker
                                                margin="normal"
                                                name="release_date_of_the_engine"
                                                label={`Release Date of the Assembly`}
                                                format={acumenCamo ? fieldDMYShort :dayMonthDateFormat}
                                                fullWidth
                                                disabled={viaBasicDetail}
                                                InputLabelProps={{ shrink: true }}
                                                error={error?.release_date_of_the_engine}
                                                helperText={error?.release_date_of_the_engine || ''}
                                                minDate={moment().subtract(25, 'years')}
                                                value={basicDetails?.off_wing_detail?.release_date_of_the_engine || null}
                                                onChange={(data, value) => { onFieldChange('release_date_of_the_engine', moment(data).isValid() ? moment(data).format(backendDateFormat) : null, 'off_wing_detail', 'date'); }}
                                                inputVariant='outlined'
                                                onBlur={(e) => {
                                                    const inputValue = e.target.value;
                                                    const isValid = moment(inputValue, dayMonthDateFormat, true).isValid();
                                                    if (isValid || inputValue === '') {
                                                        setError({})
                                                        onFieldChange('release_date_of_the_engine', inputValue === '' ? null : inputValue, 'off_wing_detail');
                                                    } else {
                                                        setError({ ...error, ['release_date_of_the_engine']: 'Invalid Date' })
                                                    }
                                                }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                    <Grid item md={4} sm={6} xs={12}>
                                        {(() => {
                                            let options = [{ label: 'Yes', value: true }, { label: 'No', value: false }];
                                            let optionValue = options.find(optionItem => optionItem.value === basicDetails?.off_wing_detail?.shop_visit_report_provided);
                                            return (
                                                <Autocomplete
                                                    disableClearable
                                                    disabled={viaBasicDetail}
                                                    options={options}
                                                    getOptionLabel={option => option.label}
                                                    name="shop_visit_report_provided"
                                                    value={optionValue}
                                                    onChange={(e, value) => onFieldChange('shop_visit_report_provided', value !== null ? value.value : null, 'off_wing_detail')}
                                                    renderInput={params => <TextField {...params} label="Shop Visit Report Provided" margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                                />
                                            )
                                        })()}
                                    </Grid>
                                    <Grid item md={4} sm={6} xs={12}>
                                        <Autocomplete
                                            options={pltConstants.filter((optionItem) => optionItem.type === 'shop_visit_type')}
                                            getOptionLabel={option => option.label}
                                            name="type_of_shop_visit"
                                            disabled
                                            value={basicDetails?.off_wing_detail?.type_of_shop_visit || null}
                                            onChange={(e, value) => onFieldChange('type_of_shop_visit', value, 'off_wing_detail')}
                                            renderInput={params => <TextField {...params} label="Type of Shop Visit" margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                        />
                                    </Grid>
                                    <Grid item md={4} sm={6} xs={12}>
                                        <MuiPickersUtilsProvider utils={MomentUtils}>
                                            <KeyboardDatePicker
                                                margin="normal"
                                                name="expected_date_of_shipment_back_to_lessee"
                                                label={`Expected Date of Shipment Back to Lessee`}
                                                format={acumenCamo ? fieldDMYShort :dayMonthDateFormat}
                                                fullWidth
                                                disabled={viaBasicDetail}
                                                InputLabelProps={{ shrink: true }}
                                                minDate={moment().subtract(25, 'years')}
                                                error={error?.expected_date_of_shipment_back_to_lessee}
                                                helperText={error?.expected_date_of_shipment_back_to_lessee || ''}
                                                value={basicDetails?.off_wing_detail?.expected_date_of_shipment_back_to_lessee || null}
                                                onChange={(data, value) => { onFieldChange('expected_date_of_shipment_back_to_lessee', moment(data).isValid() ? moment(data).format(backendDateFormat) : null, 'off_wing_detail', 'date'); }}
                                                inputVariant='outlined'
                                                onBlur={(e) => {
                                                    const inputValue = e.target.value;
                                                    const isValid = moment(inputValue, dayMonthDateFormat, true).isValid();
                                                    if (isValid || inputValue === '') {
                                                        setError({})
                                                        onFieldChange('expected_date_of_shipment_back_to_lessee', inputValue === '' ? null : inputValue, 'off_wing_detail');
                                                    } else {
                                                        setError({ ...error, ['expected_date_of_shipment_back_to_lessee']: 'Invalid Date' })
                                                    }
                                                }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                </> : null
                            }
                            {basicDetails?.off_wing_status?.value === 3 ?
                                <>
                                    <Grid item md={4} sm={6} xs={12}>
                                        <MuiPickersUtilsProvider utils={MomentUtils}>
                                            <KeyboardDatePicker
                                                margin="normal"
                                                name="expected_release_date_of_the_engine"
                                                label={`Expected Release Date of the Assembly?`}
                                                format={acumenCamo ? fieldDMYShort :dayMonthDateFormat}
                                                fullWidth
                                                disabled={viaBasicDetail}
                                                InputLabelProps={{ shrink: true }}
                                                minDate={moment().subtract(25, 'years')}
                                                error={error?.expected_release_date_of_the_engine}
                                                helperText={error?.expected_release_date_of_the_engine || ''}
                                                value={basicDetails?.off_wing_detail?.expected_release_date_of_the_engine || null}
                                                onChange={(data, value) => { onFieldChange('expected_release_date_of_the_engine', moment(data).isValid() ? moment(data).format(backendDateFormat) : null, 'off_wing_detail', 'date'); }}
                                                inputVariant='outlined'
                                                onBlur={(e) => {
                                                    const inputValue = e.target.value;
                                                    const isValid = moment(inputValue, dayMonthDateFormat, true).isValid();
                                                    if (isValid || inputValue === '') {
                                                        setError({})
                                                        onFieldChange('expected_release_date_of_the_engine', inputValue === '' ? null : inputValue, 'off_wing_detail');
                                                    } else {
                                                        setError({ ...error, ['expected_release_date_of_the_engine']: 'Invalid Date' })
                                                    }
                                                }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                    <Grid item md={4} sm={6} xs={12}>
                                        <MuiPickersUtilsProvider utils={MomentUtils}>
                                            <KeyboardDatePicker
                                                margin="normal"
                                                name="induction_date_of_engine"
                                                label={`Induction Date of Assembly`}
                                                format={acumenCamo ? fieldDMYShort :dayMonthDateFormat}
                                                fullWidth
                                                disabled={viaBasicDetail}
                                                InputLabelProps={{ shrink: true }}
                                                minDate={moment().subtract(25, 'years')}
                                                error={error?.induction_date_of_engine}
                                                helperText={error?.induction_date_of_engine || ''}
                                                value={basicDetails?.off_wing_detail?.induction_date_of_engine || null}
                                                onChange={(data, value) => { onFieldChange('induction_date_of_engine', moment(data).isValid() ? moment(data).format(backendDateFormat) : null, 'off_wing_detail', 'date'); }}
                                                inputVariant='outlined'
                                                onBlur={(e) => {
                                                    const inputValue = e.target.value;
                                                    const isValid = moment(inputValue, dayMonthDateFormat, true).isValid();
                                                    if (isValid || inputValue === '') {
                                                        setError({})
                                                        onFieldChange('induction_date_of_engine', inputValue === '' ? null : inputValue, 'off_wing_detail');
                                                    } else {
                                                        setError({ ...error, ['induction_date_of_engine']: 'Invalid Date' })
                                                    }
                                                }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                    <Grid item md={4} sm={6} xs={12}>
                                        <Autocomplete
                                            options={pltConstants.filter((optionItem) => optionItem.type === 'workscope_status')}
                                            getOptionLabel={option => option.label}
                                            name="work_scope_status"
                                            disabled={viaBasicDetail}
                                            value={basicDetails?.off_wing_detail?.work_scope_status || null}
                                            onChange={(e, value) => onFieldChange('work_scope_status', value, 'off_wing_detail')}
                                            renderInput={params => <TextField {...params} label="Workscope Status" margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                        />
                                    </Grid>
                                </> : null
                            }
                            <Grid item md={4} sm={6} xs={12}>
                                <TextField
                                    name='shop_visit_name'
                                    label='Facility Name'
                                    value={basicDetails?.off_wing_detail?.shop_visit_name || ''}
                                    fullWidth
                                    disabled={viaBasicDetail}
                                    margin="normal"
                                    onChange={(e) => onFieldChange('shop_visit_name', e.target.value, 'off_wing_detail')}
                                    InputLabelProps={{ shrink: true }}
                                    inputProps={{ maxLength: 100 }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item md={4} sm={6} xs={12}>
                                <TextField
                                    name='shop_visit_location'
                                    label='Facility Location'
                                    value={basicDetails?.off_wing_detail?.shop_visit_location || ''}
                                    fullWidth
                                    margin="normal"
                                    // onChange={(e) => onFieldChange('shop_visit_location', e.target.value, 'off_wing_detail')}
                                    InputLabelProps={{ shrink: true }}
                                    inputProps={{ maxLength: 100 }}
                                    variant='outlined'
                                    disabled
                                />
                            </Grid>
                        </> : null
                    }
                    {basicDetails?.off_wing_status?.value === 4 || basicDetails?.off_wing_status?.value === 5 ?
                        <>
                            {basicDetails?.off_wing_status?.value === 4 ?
                                <>
                                    <Grid item md={4} sm={6} xs={12}>
                                        <MuiPickersUtilsProvider utils={MomentUtils}>
                                            <KeyboardDatePicker
                                                margin="normal"
                                                name="expected_date_of_installation_on_wing"
                                                label={`Expected Date of Installation On Aircraft`}
                                                format={acumenCamo ? fieldDMYShort :dayMonthDateFormat}
                                                fullWidth
                                                disabled={viaBasicDetail}
                                                InputLabelProps={{ shrink: true }}
                                                minDate={moment().subtract(25, 'years')}
                                                error={error?.expected_date_of_installation_on_wing}
                                                helperText={error?.expected_date_of_installation_on_wing || ''}
                                                value={basicDetails?.off_wing_detail?.expected_date_of_installation_on_wing || null}
                                                onChange={(data, value) => { onFieldChange('expected_date_of_installation_on_wing', moment(data).isValid() ? moment(data).format(backendDateFormat) : null, 'off_wing_detail', 'date'); }}
                                                inputVariant='outlined'
                                                onBlur={(e) => {
                                                    const inputValue = e.target.value;
                                                    const isValid = moment(inputValue, dayMonthDateFormat, true).isValid();
                                                    if (isValid || inputValue === '') {
                                                        setError({})
                                                        onFieldChange('expected_date_of_installation_on_wing', inputValue === '' ? null : inputValue, 'off_wing_detail');
                                                    } else {
                                                        setError({ ...error, ['expected_date_of_installation_on_wing']: 'Invalid Date' })
                                                    }
                                                }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                    <Grid item md={4} sm={6} xs={12}>
                                        {(() => {
                                            let options = [{ label: 'Yes', value: true }, { label: 'No', value: false }];
                                            let optionValue = options.find(optionItem => optionItem.value === basicDetails?.off_wing_detail?.shop_visit_performed);
                                            return (
                                                <Autocomplete
                                                    disableClearable
                                                    disabled={viaBasicDetail}
                                                    options={options}
                                                    getOptionLabel={option => option.label}
                                                    name="shop_visit_performed"
                                                    value={optionValue}
                                                    onChange={(e, value) => onFieldChange('shop_visit_performed', value !== null ? value.value : null, 'off_wing_detail')}
                                                    renderInput={params => <TextField {...params} label="Shop Visit Performed" margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                                />
                                            )
                                        })()}
                                    </Grid>
                                    <Grid item md={4} sm={6} xs={12}>
                                        <Autocomplete
                                            options={pltConstants.filter((optionItem) => optionItem.type === 'sv_report_status')}
                                            getOptionLabel={option => option.label}
                                            name="shop_visit_report_status"
                                            disabled={viaBasicDetail}
                                            value={basicDetails?.off_wing_detail?.shop_visit_report_status || null}
                                            onChange={(e, value) => onFieldChange('shop_visit_report_status', value, 'off_wing_detail')}
                                            renderInput={params => <TextField {...params} label="Shop Visit Report Status" margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                        />
                                    </Grid>
                                </> : null
                            }
                            {basicDetails?.off_wing_status?.value === 5 ?
                                <>
                                    <Grid item md={4} sm={6} xs={12}>
                                        <Autocomplete
                                            options={pltConstants.filter((optionItem) => optionItem.type === 'sv_requirement')}
                                            getOptionLabel={option => option.label}
                                            name="shop_visit_requirement"
                                            disabled={viaBasicDetail}
                                            value={basicDetails?.off_wing_detail?.shop_visit_requirement || null}
                                            onChange={(e, value) => onFieldChange('shop_visit_requirement', value, 'off_wing_detail')}
                                            renderInput={params => <TextField {...params} label="Shop Visit Requirement" margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                        />
                                    </Grid>
                                    <Grid item md={4} sm={6} xs={12}>
                                        <MuiPickersUtilsProvider utils={MomentUtils}>
                                            <KeyboardDatePicker
                                                margin="normal"
                                                name="expected_date_of_shipment_to_shop"
                                                label={`Expected Date of Shipment to Shop`}
                                                format={acumenCamo ? fieldDMYShort :dayMonthDateFormat}
                                                fullWidth
                                                disabled={viaBasicDetail}
                                                InputLabelProps={{ shrink: true }}
                                                minDate={moment().subtract(25, 'years')}
                                                error={error?.expected_date_of_shipment_to_shop}
                                                helperText={error?.expected_date_of_shipment_to_shop || ''}
                                                value={basicDetails?.off_wing_detail?.expected_date_of_shipment_to_shop || null}
                                                onChange={(data, value) => { onFieldChange('expected_date_of_shipment_to_shop', moment(data).isValid() ? moment(data).format(backendDateFormat) : null, 'off_wing_detail', 'date'); }}
                                                inputVariant='outlined'
                                                onBlur={(e) => {
                                                    const inputValue = e.target.value;
                                                    const isValid = moment(inputValue, dayMonthDateFormat, true).isValid();
                                                    if (isValid || inputValue === '') {
                                                        setError({})
                                                        onFieldChange('expected_date_of_shipment_to_shop', inputValue === '' ? null : inputValue, 'off_wing_detail');
                                                    } else {
                                                        setError({ ...error, ['expected_date_of_shipment_to_shop']: 'Invalid Date' })
                                                    }
                                                }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                    <Grid item md={4} sm={6} xs={12}>
                                        <TextField
                                            name='selected_shop'
                                            label='Which Shop has Been Selected?'
                                            value={basicDetails?.off_wing_detail?.selected_shop || ''}
                                            fullWidth
                                            disabled={viaBasicDetail}
                                            margin="normal"
                                            onChange={(e) => onFieldChange('selected_shop', e.target.value, 'off_wing_detail')}
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{ maxLength: 100 }}
                                            variant='outlined'
                                        />
                                    </Grid>
                                </> : null
                            }
                            <Grid item md={4} sm={6} xs={12}>
                                <TextField
                                    name='off_wing_location'
                                    label='Asset Location'
                                    value={basicDetails?.off_wing_detail?.off_wing_location || ''}
                                    fullWidth
                                    disabled={viaBasicDetail}
                                    margin="normal"
                                    onChange={(e) => onFieldChange('off_wing_location', e.target.value, 'off_wing_detail')}
                                    InputLabelProps={{ shrink: true }}
                                    inputProps={{ maxLength: 100 }}
                                    variant='outlined'
                                />
                            </Grid>
                        </> : null
                    }
                </Grid> : null
            }
        </>
    )
}
export default withRouter(EngOnOffWing);